const EARN_BADGES_FEATURE = [
  {
    src: new URL(
      '~/public/assets/images/Landing/earnBadgesFeature.png?as=avif',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/earnBadgesFeature.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/earnBadgesFeature.png',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/png'
  }
]

export default EARN_BADGES_FEATURE
